import { useEffect } from 'react'
import useActivationObject from '../../../providers/ActivationObjectProvider/hooks/useActivationObject'
import { Step3Props, useStep3Props } from '../types'
import useStep3Ares from './useStep3.ares'
import useStep3Form from './useStep3.form'
import useStep3FormConditions from './useStep3.form.conditions'
import useStep3FormOptions from './useStep3.form.options'
import useStep3FormStreet from './useStep3.form.street'
import { DynamicRequestBody } from '../../../../api/dynamicSites/types'
import { useDynamicDataMutation } from '../../../../api/dynamicSites/hooks'

const useStep3 = (props: useStep3Props): Step3Props => {
    const { data: activationObject, isUpdating } = useActivationObject()
    const aresProps = useStep3Ares(activationObject)
    const formProps = useStep3Form(aresProps, activationObject)
    const optionsProps = useStep3FormOptions(
        formProps.form,
        aresProps,
        activationObject,
    )
    const conditionsProps = useStep3FormConditions(
        formProps.form,
        optionsProps,
        aresProps,
        activationObject,
    )
    const streetSugestionsProps = useStep3FormStreet(formProps.form)

    const {
        data: dynamicData,
        mutate: mutateDynamicData,
        isLoading: dynamicDataLoading,
    } = useDynamicDataMutation()

    useEffect(() => {
        if (activationObject) {
            const dynamicBody = {
                synonym: activationObject.synonym,
                type: 'Redirect',
                mainSite: activationObject.actualWizardStep.mainStep,
                dynamicSiteNumber: activationObject.actualWizardStep.subStep,
            } as DynamicRequestBody

            mutateDynamicData({ ...dynamicBody })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return {
        ...props,
        activationObject,
        ares: aresProps,
        form: formProps,
        options: optionsProps,
        conditions: conditionsProps,
        streetSugestions: streetSugestionsProps,
        isUpdating,
        dynamicSiteData: dynamicData?.site,
        dynamicDataLoading,
    }
}

export default useStep3
